import { mapData } from '@/utilities/DataMapping';
import { Utils } from '@/utilities/Utils';

export interface IBookingHotelVM {
    bookingHotelID: number;
    id: number;
    guid: string;
    bookingID: number;
    name: string;
    address1: string;
    address2: string;
    address3: string;
    town: string;
    postCode: string;
    contactName: string;
    contactPhoneNumber: string;
    numberOfRooms: number;
    adminFees: number;
    adminFeesPercentage: number;
    adminFeesCalculated: number;
    allocatedRooms: number;
    total: number;
    canDelete: boolean;
    hotelNotes: string;
    contractorNotes: string;
    preferredHotel: boolean;
    webAddress: string;
    distanceFromJob: number;
    averageCost: number;
    latitude: number;
    longitude: number;
}

export class BookingHotelVM implements IBookingHotelVM {

    constructor(data?: IBookingHotelVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingHotelVM) {
        mapData(data, {
            root: () => this
        });
    }

    bookingHotelID: number = 0;
    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    bookingID: number = 0;
    name: string = "";
    address1: string = "";
    address2: string = "";
    address3: string = "";
    town: string = "";
    postCode: string = "";
    contactName: string = "";
    contactPhoneNumber: string = "";
    numberOfRooms: number = 0;
    adminFees: number = 0;
    adminFeesPercentage: number = 0;
    adminFeesCalculated: number = 0;
    allocatedRooms: number = 0;
    total: number = 0;
    canDelete: boolean = false;
    hotelNotes: string = "";
    contractorNotes: string = "";
    preferredHotel: boolean = false;
    webAddress: string = "";
    distanceFromJob: number = 0;
    averageCost: number = 0;
    latitude: number = 0;
    longitude: number = 0;
}